import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

type TextTransform =
  | 'none'
  | 'capitalize'
  | 'uppercase'
  | 'lowercase'
  | 'initial'
  | 'inherit'

export interface HeadingSmallProps {
  bold?: boolean
  textTransform?: TextTransform
  margin?: number
  className?: string
}

const HEADING_SMALL_STYLES = 'text-2xl mt-2 mr-0 mb-2 ml-0 font-heading text-secondary'
const FONT_WEIGHT_SEMI_BOLD = 'font-bold'
const FONT_HAIR_LINE = 'font-semibold'

export const HeadingSmall: React.FC<PropsWithChildren<HeadingSmallProps>> = ({
  bold = false,
  textTransform,
  margin,
  className,
  children,
}) => {
  return (
    <h2
      style={{ textTransform: textTransform ?? 'none', margin }}
      className={concatStyles([
        HEADING_SMALL_STYLES,
        bold ? FONT_WEIGHT_SEMI_BOLD : FONT_HAIR_LINE,
        className,
      ])}
    >
      {children}
    </h2>
  )
}

HeadingSmall.displayName = 'Content.HeadingSmall'
